import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import InnovationTechnologyDetails from '../mendepartmentdetails/InnovationTechnology'


function InnovationTechnology() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Innovation and Technology || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Innovation Technology"
            subtitledown="Department of Innovation & Technology"
           />
            <InnovationTechnologyDetails/>
        </div>
    </>
  )
}

export default InnovationTechnology